module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABMklEQVQ4T7WUQU7CQBiF/0dJiDtcol3oDeqCZLpST+ARwBPoEfQGeALhJMKKP2Fhb6ALoku7MyToM9OktaVQ2obOppPJP1/fP+/NQA48cGCeNA/88rzud6czINC16lsis57q1M6X/b4Hx7mxc5Dh0Wo1OQ6CMN1lRqHdIO32C0QiWDLIMYEQIveZZZFQ1utrd7EI4vUE+GnM2Q/wmoPtOWSKhA550VN9j5TH9UvfH0Hkro5JFHly5/NI/T/QmCmAy1pAcuaqXjUL/DDGHvygjkKQkxPVYUahNeUXeKsDbJHnOVOinBkzBPBcBUry1lUd52KTuF0BugnLtJxWVSpC5OOp6sNmNzvvcpFJaRNKA23hNmgRbGfL6b+moftgpYCR+74/st/4ehWloPn3sEoGt9X+Ac5+ghUP23MeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/profile/you_like.png
// module id = 7Vtw
// module chunks = 1